import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _BankingEntity, _PaymentType } from '../../../../core/services/dataBean/EntityCatalog';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const BakingEntityEditor = ({ idSelector, onChange, label }: Props) => {

    const BankingEntity = useDataBean(_BankingEntity)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState<number>(null);

    useEffect(() => {
            setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(e);
    }



    const getLista = () => {

        BankingEntity.instance.getBankingEntityCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    return (
        <>
            <label>{label ?? "Entidades Financieras:"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBankingEntity} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}